export const money = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
});
